'use client';

export type AuthStatus = 'guest' | 'authenticated';

const signOutInProgressKey = 'lexora:signOutInProgress';
const signOutInProgressTtlMs = 5 * 60 * 1000;
const autoSignInKey = 'lexora:autoSignInAt';
const autoSignInThrottleMs = 15 * 1000;
const legacyUserKey = 'user';

let signupRequested = false;

const isFreshTimestamp = (key: string, ttlMs: number): boolean => {
    const startedAt = Number(sessionStorage.getItem(key));
    if (!Number.isFinite(startedAt) || startedAt <= 0) {
        sessionStorage.removeItem(key);
        return false;
    }

    if (Date.now() - startedAt > ttlMs) {
        sessionStorage.removeItem(key);
        return false;
    }

    return true;
};

export const auth = {
    clearLegacyUserCache(): void {
        if (typeof window === 'undefined') return;
        localStorage.removeItem(legacyUserKey);
    },

    markSignOutInProgress(): void {
        if (typeof window === 'undefined') return;
        sessionStorage.setItem(signOutInProgressKey, Date.now().toString());
    },

    clearSignOutInProgress(): void {
        if (typeof window === 'undefined') return;
        sessionStorage.removeItem(signOutInProgressKey);
    },

    consumeSignOutFlag(): boolean {
        if (typeof window === 'undefined') return false;
        const wasSignedOut = isFreshTimestamp(signOutInProgressKey, signOutInProgressTtlMs);
        sessionStorage.removeItem(signOutInProgressKey);

        const url = new URL(window.location.href);
        if (url.searchParams.get('from') === 'landing') {
            signupRequested = url.searchParams.get('intent') === 'signup';
            url.searchParams.delete('from');
            url.searchParams.delete('intent');
            window.history.replaceState(window.history.state, '', url);
            sessionStorage.removeItem(autoSignInKey);
            return false;
        }

        return wasSignedOut;
    },

    markAutoSignIn(): void {
        if (typeof window === 'undefined') return;
        sessionStorage.setItem(autoSignInKey, Date.now().toString());
    },

    isAutoSignInThrottled(): boolean {
        if (typeof window === 'undefined') return false;
        return isFreshTimestamp(autoSignInKey, autoSignInThrottleMs);
    },

    isSignupRequested(): boolean {
        return signupRequested;
    },
};
